const routeParameters: Record<string, string> = {
  friendId: ':friendId',
  senderId: ':senderId',
  letterId: ':letterId',
  invitationId: ':invitationId',
  token: ':token',
};

export const routes = {
  root: '/',
  logIn: '/log-in',
  register: '/register',
  forgotPassword: '/forgot-password/',
  passwordReset: `/password-reset/${routeParameters.token}`,
  letterViewer: `/letter/${routeParameters.letterId}`,
  invitations: '/invitations',
  inviteWithLetter: '/invite-with-a-letter',
  helpAndFeedback: '/help-and-feedback',
  accountSettings: '/account-settings',
  writeToMe: `/write-to-me/${routeParameters.invitationId}`,
  letterInvite: `/letter-invite/${routeParameters.invitationId}`,
  newLetter: '/new-letter',
  preComposer: `/write-to/${routeParameters.friendId}`,
  composer: `/composer/${routeParameters.letterId}`,
  site: {
    blog: 'https://www.letterdesk.app/blog',
    landingPage: 'https://www.letterdesk.app/',
    roots: 'https://roots.letterdesk.app/',
  },
};

const substituteRoute = (mapping: Record<string, string>, route: string) => {
  const reducer = (route: string, [key, value]: [string, string]) =>
    route.replace(routeParameters[key], value);

  return Object.entries(mapping).reduce(reducer, route);
};

function makeFormatter<T extends Record<string, string>>(route: string) {
  return (mapping: T) => substituteRoute(mapping, route);
}

export type MatchProps<Parameters> = { match: { params: Parameters } };

export type ComposerParameters = { letterId: string };
export type PreComposerParameters = { friendId: string };
export type WriteToMeParameters = { invitationId: string };
export type LetterInviteParameters = { invitationId: string };
export type LetterViewerParameters = { letterId: string };
export type ResetPasswordParameters = { token: string };

export const formatComposer = makeFormatter<ComposerParameters>(routes.composer);
export const formatPreComposer = makeFormatter<PreComposerParameters>(routes.preComposer);
export const formatLetterViewerRoute = makeFormatter<LetterViewerParameters>(routes.letterViewer);
